import {Box, IconButton, Stack, Typography} from "@mui/joy";
import Logo from "../assets/icon_app_rounded.png";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {Logout, Person} from "@mui/icons-material";
import React, {useContext, useState} from "react";
import {Link} from "react-router-dom";
import {LANGUAGES} from "../utils/Utils";
import {useTranslation} from "react-i18next";
import {AuthContext, AUTHSTATES} from "../utils/AuthProvider";
import {ConfirmDialog} from "../components/ConfirmDialog";

// Navbar snella e "sticky" (segue lo scroll, non più `position: fixed` a
// tutta larghezza sopra il contenuto): sfondo vetro/blur, bordo sottile,
// stessa larghezza massima delle pagine sotto per restare allineata.
export function Navbar() {
    const { i18n, t } = useTranslation();
    const {authState} = useContext(AuthContext)
    const [confirmLogout, setConfirmLogout] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);

    function changeLang(code: string) {
        i18n.changeLanguage(code);
    }

    async function logout() {
        setLoggingOut(true);
        await firebase.auth().signOut();
        setLoggingOut(false);
        setConfirmLogout(false);
    }

    return (
        <Box
            component="nav"
            sx={{
                position: "sticky",
                top: 0,
                zIndex: 20,
                backgroundColor: "rgba(10,10,12,0.72)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
            }}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{maxWidth: 1000, mx: "auto", px: {xs: 2, sm: 3}, py: 1.25}}
            >
                <Stack
                    spacing={1}
                    direction="row"
                    alignItems="center"
                    onClick={() => { window.location.href = "https://cinefx.danieledigregorio.it"; }}
                    sx={{cursor: "pointer"}}
                >
                    <img src={Logo} alt="Logo" width={32} height={32} style={{borderRadius: 8}} />
                    <Typography level="title-md" fontWeight="bold">CineFX</Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                    {
                        authState !== AUTHSTATES.LOGGEDOUT &&
                        <>
                            <Link to="/">
                                <IconButton variant="plain" color="neutral" size="sm" title={t("account")}>
                                    <Person />
                                </IconButton>
                            </Link>
                            <IconButton
                                variant="plain"
                                color="neutral"
                                size="sm"
                                title={t("logout")}
                                onClick={() => setConfirmLogout(true)}
                            >
                                <Logout />
                            </IconButton>
                        </>
                    }
                    <IconButton
                        variant="plain"
                        color="neutral"
                        size="sm"
                        onClick={() => {
                            if(i18n.language === LANGUAGES[1].code) {
                                changeLang(LANGUAGES[0].code)
                            } else {
                                changeLang(LANGUAGES[1].code)
                            }
                        }}
                    >
                        {
                            i18n.language === LANGUAGES[1].code ?
                                LANGUAGES[0].flag
                                :
                                LANGUAGES[1].flag
                        }
                    </IconButton>
                </Stack>
            </Stack>

            <ConfirmDialog
                open={confirmLogout}
                title={t("logoutdialogtitle")}
                description={t("logoutdialogdescription")}
                confirmLabel={t("logout")}
                cancelLabel={t("closelabel")}
                confirmColor="danger"
                loading={loggingOut}
                onConfirm={logout}
                onClose={() => setConfirmLogout(false)}
            />
        </Box>
    )
}
